import instance from "./ApiServices";
import authHeader from "./auth-header";

const getAll = () => {
  return instance.get("/gallery", { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/gallery/${id}`, { headers: authHeader() });
};

const create = (data) => {
  return instance.post("/gallery", data, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/gallery/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/gallery/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return instance.delete(`/gallery`);
};

const findByTitle = (title) => {
  return instance.get(`/gallery?title=${title}`);
};

const GalleryService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default GalleryService;
